module.exports = __webpack_public_path__ + "static/media/PhoneCalling.99fc6493.svg";